var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPripomienky(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_39711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.334 1.58203H2.66732C1.93398 1.58203 1.34065 2.18203 1.34065 2.91536L1.33398 14.9154L4.00065 12.2487H13.334C14.0673 12.2487 14.6673 11.6487 14.6673 10.9154V2.91536C14.6673 2.18203 14.0673 1.58203 13.334 1.58203ZM11.334 9.58203H4.66732C4.30065 9.58203 4.00065 9.28203 4.00065 8.91536C4.00065 8.5487 4.30065 8.2487 4.66732 8.2487H11.334C11.7007 8.2487 12.0007 8.5487 12.0007 8.91536C12.0007 9.28203 11.7007 9.58203 11.334 9.58203ZM11.334 7.58203H4.66732C4.30065 7.58203 4.00065 7.28203 4.00065 6.91536C4.00065 6.5487 4.30065 6.2487 4.66732 6.2487H11.334C11.7007 6.2487 12.0007 6.5487 12.0007 6.91536C12.0007 7.28203 11.7007 7.58203 11.334 7.58203ZM11.334 5.58203H4.66732C4.30065 5.58203 4.00065 5.28203 4.00065 4.91536C4.00065 4.5487 4.30065 4.2487 4.66732 4.2487H11.334C11.7007 4.2487 12.0007 4.5487 12.0007 4.91536C12.0007 5.28203 11.7007 5.58203 11.334 5.58203Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_39711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPripomienky);
export default __webpack_public_path__ + "static/media/icon-pripomienky.8828cc3412f0e394479a3a79cc0a83fa.svg";
export { ForwardRef as ReactComponent };